export { default } from './PricingCard';



// WEBPACK FOOTER //
// ./src/components/organisms/PricingCard/index.js